/** @jsx jsx */
import PropTypes from 'prop-types'
import { jsx } from '@emotion/core'

const propTypes = {
	src: PropTypes.string.isRequired,
	alt: PropTypes.string,
}
const defaultProps = {}

const WithoutChrome = ({ src }) => {
	// const imageURL = new URL(`https://fa-work-api.edgeapp.net/render/${renderKey}`)
	// imageURL.searchParams.set('w', 375)
	// imageURL.searchParams.set('h', 667)
	// imageURL.searchParams.set('dpr', 2)

	return (
		<div
			data-comp="mobile-screen-without-chrome"
			css={{
				position: 'relative',
				flex: 1,
			}}
		>
			<div
				css={{
					display: 'block',
					position: 'absolute',
					top: 0,
					left: 0,
					width: '100%',
					height: '100%',
					background: `top left url(${src}) no-repeat`,
					backgroundSize: 'cover',
				}}
			/>
			<svg
				width="100%"
				height="100%"
				viewBox="0 0 375 667"
				css={{
					position: 'relative',
					zIndex: 100,
					display: 'block',
					maxWidth: '100%',
				}}
			/>
		</div>
	)
}

WithoutChrome.propTypes = propTypes
WithoutChrome.defaultProps = defaultProps

export default WithoutChrome
